<template>
  <div>
    <div class="center-right">
      <el-dialog
        customClass="customWidth"
        :visible.sync="dialogVisible"
        :show-close="false"
        :lock-scroll="false"
        :center="true"
        title=""
      >
        <div slot="title" class="dialog-title">
          <img :src="this.imgPath" alt="" />
          <h2>{{ this.title }}</h2>
        </div>
        <img
          class="dialog-close"
          src="@/assets/img/case/icon_close@2x.png"
          @click="dialogVisible = false"
        />
      </el-dialog>

      <ul class="anfanghangyexiehui">
        <li v-for="(person, index) in arr" :key="index" class="infoContainer">
          <div class="img">
            <img @click="toggle(index)" :src="person.imgPath" />
          </div>
          <div class="text">
            <div class="textContent">
              {{ person.title }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "security2",
  data() {
    return {
      centerDialogVisible: false,
      arr: [],
      status: 1,
      type: 3,
      imgPath: "",
      title: "",
      dialogVisible: false,
    };
  },
  mounted() {
    this.select();
    window.toggle = this.toggle;
  },
  methods: {
    select() {
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 200,
            category: "行业协会-安防行业",
          },
        })
        .then((res) => {
          console.log(res.data);
          this.arr = res.data.data;
        });
    },
    toggle(index) {
      if (index >= 0) {
        this.imgPath = this.arr[index].imgPath;
        this.title = this.arr[index].title;
        // this.content = this.getSimpleText(this.arr[index].content)
      }
      //   var sy = document.getElementById("accc").style.display
      //   if(sy === "inline"){
      //     document.getElementById("accc").style.display="none";
      //   }else{
      //     document.getElementById("accc").style.display="inline";
      //   }
      //   console.log(document.getElementById("accc").style.display+"###")
      //   var blur = document.getElementById('blurr');
      //   blur.classList.toggle('active')
      //   var popular = document.getElementById('popular');
      //   popular.classList.toggle('active')
      //    var acc = document.getElementById('accc');
      //  acc.classList.toggle('active')

      this.dialogVisible = true;
      document.body.style.paddingRight = "0px";
    },
    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”",
      };
      return html
        .replace(re1, "")
        .replace(
          /&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi,
          function (all, t) {
            return arrEntities[t];
          }
        );
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/qualificationCenter.css";
.dialog-close {
  position: absolute;
  top: 0;
  right: -56px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.dialog-title img {
  padding: 0vw;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#accc {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
  display: none;
}
#blurr.active {
  pointer-events: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
ul {
  width: 100%;
  /* background-color: red; */
}
/* .center-right ul li {
  width: 245px;
  height: 180px;
  margin-right: 24px;
  margin-bottom: 40px;
  display: inline-block;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
  cursor: pointer;
}
.center-right ul li:nth-child(4) {
  width: 265px;
  height: 286px;
  margin-right: 0px;
  display: inline-block;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
} */
/* .center-right ul li .img {
  position: relative;
  height: 195px;
  background-color: #f1f4fb;
} */
/* .center-right ul li .img img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 80%;
  object-fit: contain;
} */
/* .center-right ul li .text {
  position: absolute;
  width: 245px;
  height: 84px;
  background-color: rgba(255, 255, 255, 0.88);
  font-size: 15px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.58);
  line-height: 29px;
  letter-spacing: 0.96px;
}
.center-right ul li .text .textContent {
  width: 206px;
  height: 59px;
  margin: 16px 42px 16px 16px;
} */
#accc {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
  display: none;
}
#blurr.active {
  pointer-events: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
body {
  position: relative;
}
.none {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 975px;
  background-color: bisque;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
.none .button {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 33px;
}
.none .a {
  position: absolute;
  right: -45px;
  top: -13px;
  display: block;
  width: 26px;
  height: 26px;
  cursor: pointer;
  background: url(../../assets/img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none img {
  width: 910px;
  height: 618px;
}
.none h1 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 0.9984px;
}
.none p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 28px;
  letter-spacing: 0.9984px;
  padding-bottom: 40px;
}
#popular.active {
  top: 375px;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/qn/security2.vue